import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Input from "../shared/Input";
import { fetchData, fetchFormData } from "../../utils/options";
import topTost from "../../utils/topTost";

const TaskCategoryCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const [taskCategory, setTaskCategory] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);
  const Id = localStorage.getItem("id");
  const fetchDetails = async (id) => {
    try {
      const formData = new FormData();
      formData.append("id", id);

      const result = await fetchFormData(
        `task-category/getbyid`,
        formData,
        "POST"
      );

      if (result && result.data) {
        setTaskCategory(result.data.task_category);
        console.log(result.data.task_category);
      } else {
        console.warn("State data not found.");
        setTaskCategory("");
      }
    } catch (error) {
      console.error("Failed to fetch user details:", error);
      setTaskCategory("");
    }
  };

  useEffect(() => {
    if (id) {
      fetchDetails(id);
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("task_category", taskCategory);
    formData.append("status", "1");
    formData.append("userId", userId);
    formData.append("moduleId", M_id);
    formData.append("branchID", "1");
    formData.append("moduleId", M_id);
    formData.append("created_by", userId);
    try {
      let response;

      if (id) {
        formData.append("id", id);
        response = await fetchFormData(
          "task-category/update",
          formData,
          "POST"
        );
      } else {
        response = await fetchFormData("task-category/add", formData, "POST"); // ✅ Use correct API for add
      }

      if (response && response.message === "Category added") {
        topTost({
          title: response.message,
          icon: "success",
        });
        navigate(`/task/task-category-list?id=${M_id}`);
        console.log(" operation successful", response);
      } else if (response && response.message === "Category updated") {
        topTost({
          title: response.message,
          icon: "success",
        });
        navigate("/task/task-category-list");
        console.log(" operation successful", response);
      } else {
        console.error(" operation failed", response);
      }
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <div className="mb-5 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0 me-4">
                <span className="d-block mb-2">
                  {id ? "Edit Task Category:" : "Add Task Category:"}
                </span>
              </h5>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <Input
                    icon="feather-briefcase"
                    label="Task Category"
                    labelId="taskCategroyInput"
                    placeholder="Task Category"
                    name="task_category"
                    value={taskCategory}
                    required
                    onChange={(name, value) => setTaskCategory(value)}
                  />
                </div>
                <div className="col-md-6">
                  <button
                    type="submit"
                    className="btn btn-lg btn-primary"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default TaskCategoryCreate;
